import { Directive } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { RdrFormlyFieldConfig } from '@app/formly/types/basefield/basefield.component';

@Directive()
export class BasefieldV2Component extends FieldType<RdrFormlyFieldConfig> {}
